import type { FC, ReactNode } from "react";
import { cn } from "@/lib/cn";

type InquiryNewBadgeProps = {
  children?: ReactNode;
  size?: "m" | "l";
  className?: string;
};

/**
 * The solid orange pill Figma uses for "New" / "N New" (2:12868, 2:12915, 2:13399) — a different
 * shape from `StatusBadge`'s outlined dot style, which this design doesn't use anywhere.
 */
export const InquiryNewBadge: FC<InquiryNewBadgeProps> = ({ children = "New", size = "m", className }) => (
  <span
    className={cn(
      "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-circle bg-warning px-16 py-4 font-medium leading-[1.4] text-neutral-white",
      size === "l" ? "text-16" : "text-14",
      className,
    )}
  >
    {children}
  </span>
);
